<cue-modal [modal]="modal" class="notch-fix" data-cy="assist-reservation-delete-dialog">
  <cue-modal-header [title]="titleKey() | transloco" />
  <cue-modal-body>
    <div class="modal-body">
      <p class="text-center question">
        {{ questionKey() | transloco }}
        {{ reservation().subject }} ?
      </p>
    </div>
  </cue-modal-body>
  <cue-modal-footer>
    <cue-button
      data-cy="assist-reservation-delete-cancel"
      (click)="modal.close(0)"
      [icon]="cueClose"
      [smallResponsive]="true"
    >
      {{ closeKey() | transloco }}
    </cue-button>
    <cue-button
      data-cy="assist-reservation-delete-confirm"
      (click)="modal.close(1)"
      [icon]="cueDelete"
      [type]="'delete'"
      [smallResponsive]="true"
    >
      {{ confirmButtonKey() | transloco }}
    </cue-button>
  </cue-modal-footer>
</cue-modal>
